import iwelcome from "@/assets/top-selling/welcome.jpg";
import lwelcome from "@/assets/top-selling/welcome-l.jpg";

import iluca from "@/assets/top-selling/luca.jpg";
import lluca from "@/assets/top-selling/luca-l.jpg";

import imaster from "@/assets/top-selling/master.jpg";
import lmaster from "@/assets/top-selling/master-l.jpg";

import ipenthouse from "@/assets/top-selling/penthouse.jpg";
import lpenthouse from "@/assets/top-selling/penthouse-l.jpg";

import ibar from "@/assets/top-selling/bar.jpg";
import lbar from "@/assets/top-selling/bar-l.jpg";

import ilobby from "@/assets/top-selling/lobby.jpg";
import llobby from "@/assets/top-selling/lobby-l.jpg";

import iartisan from "@/assets/top-selling/artisan.jpg";
import lartisan from "@/assets/top-selling/artisan-l.jpg";

import igrace from "@/assets/top-selling/grace.jpg";
import lgrace from "@/assets/top-selling/grace-l.jpg";

export default [
  {
    key: 0,
    label: "welcome",
    image: {
      src: iwelcome,
      loading: lwelcome
    }
  },
  {
    key: 4,
    label: "grace garden",
    image: {
      src: igrace,
      loading: lgrace
    }
  },
  {
    key: 1,
    label: "lobby",
    image: {
      src: ilobby,
      loading: llobby
    }
  },
  {
    key: 2,
    label: "luca",
    image: {
      src: iluca,
      loading: lluca
    }
  },
  {
    key: 3,
    label: "the guild bar",
    image: {
      src: ibar,
      loading: lbar
    }
  },
  {
    key: 5,
    label: "artisan king room",
    image: {
      src: iartisan,
      loading: lartisan
    }
  },
  {
    key: 6,
    label: "master suite",
    image: {
      src: imaster,
      loading: lmaster
    }
  },
  {
    key: 7,
    label: "penthouse suite",
    image: {
      src: ipenthouse,
      loading: lpenthouse
    }
  }
];
